import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import './styles/index'
import AfterLifeEditor from './Layouts/AfterLifeEditor';
import "react-toastify/dist/ReactToastify.css";
import ReceiverUi from './Pages/debug/Receiver';
;

function App() {
 
  return (
      <>
          <Routes>
      
              <Route path="/msg" element={<ReceiverUi/> }/>
              <Route path="/" element={<AfterLifeEditor />} />
              <Route path="newDesign" element={<AfterLifeEditor />} />
              <Route path="createCopy/:id" element={<AfterLifeEditor action="createCopy" />} />
              <Route path="editProject/:id" element={<AfterLifeEditor action="editProject" />} />
              <Route path="editTemplate/:id" element={<AfterLifeEditor action="editTemplate" />} />
          </Routes>
      </>
  );
}

export default App;
